module.exports = __webpack_public_path__ + "img/china_telecom_icon.2db5231d.svg";